import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
} from "../../Util/authRedirect";

const PrivatePublicRoute = () => {
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(userData);
  const location = useLocation();

  if (!rehydrated) return <LoaderComponent />;
  if (!authToken) return <Outlet />;

  // Allow authenticated users to view the review agreement page
  if (location.pathname === "/review-agreement") {
    return <Outlet />;
  }

  return <Navigate to={getAuthenticatedHomeRoute(userData)} replace />;
};

export default PrivatePublicRoute;
